<template>
	<div style="display: flex; flex-direction: row; background-color: #efefef; justify-content: space-between; padding: 20px; border-radius: 10px;">
		<div class="pannel" v-if="shopInfo">
			<div class="title">店铺信息</div>
			<div class="form-line">
				<div class="form-name">推荐PID</div>
				<el-input class='form-inp' v-model="shopInfo.pid" size="small"></el-input>
				<el-button circle type="danger" @click="editPid()" icon="el-icon-edit" size="mini"></el-button>
			</div>
			<div class="form-line">
				<div class="form-name">店铺名</div>
				<el-input class='form-inp' v-model="shopInfo.shop_name" size="small"></el-input>
				<el-button circle type="danger" @click="editShopName()" icon="el-icon-edit" size="mini"></el-button>
			</div>
			<div class="form-line">
				<div class="form-name">店铺账号</div>
				<el-input class='form-inp' v-model="shopInfo.username" size="small"></el-input>
				<el-button circle type="danger" @click="editUsername()" icon="el-icon-edit" size="mini"></el-button>
			</div>
			<div class="form-line">
				<div class="form-name">登录密码</div>
				<el-button type="primary" size="mini" @click="resetPass()">重置密码</el-button>
			</div>
			<div class="form-line">
				<div class="form-name">支付密码</div>
				<el-button type="primary" size="mini" @click="resetPayPass()">重置为空</el-button>
			</div>
			<div class="form-line">
				<div class="form-name">独立跟单大厅</div>
				<el-switch  v-model="shopInfo.singleFollow" :active-value="1" :inactive-value="0" @change="followStatus">
				</el-switch>
			</div>
			<div class="form-line">
				<div class="form-name">独立跟单类型</div>
				<el-radio-group v-model="shopInfo.singleType" size="small" @change="followType">
					<el-radio-button :label="0">关闭</el-radio-button>
					<el-radio-button :label="1" >独立</el-radio-button>
					<el-radio-button :label="2">混合</el-radio-button>
				</el-radio-group>
			</div>
		</div>
		<div class="pannel">
			<div class="title">店铺信息</div>
			<div class="form-line">
				<div class="form-name">允许店主登录</div>
				<el-switch  v-model="shopInfo.status" :active-value="1" :inactive-value="99" @change="shopStatus">
				</el-switch>
			</div>
			<div class="form-line">
				<div class="form-name">限制会员登录</div>
				<el-button type="warning" size="mini" @click="forbidLogin(0)">一键限制会员登录</el-button>
			</div>
			<div class="form-line">
				<div class="form-name">允许会员登录</div>
				<el-button type="success" size="mini" @click="forbidLogin(1)">一键允许会员登录</el-button>
			</div>
			<div class="form-line">
				<div class="form-name">服务费(%)</div>
				<el-input class='form-inp' v-model="shopInfo.rates" size="small"></el-input>
				<el-button circle type="danger" @click="editRateName()" icon="el-icon-edit" size="mini"></el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:['sid'],
		data(){
			return {
				shopInfo:null
			}
		},
		watch:{
		},
		created() {
			this.getData();
		},
		methods:{
			forbidLogin(_status){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/forbidUserLogin", {sid:_this.sid, status: _status}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			followType(e){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editSingleType", {sid:_this.sid, status: e}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			shopStatus(e){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editShopStatus", {sid:_this.sid, status: e}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			followStatus(e){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editSingleFollow", {sid:_this.sid, status: e}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			editPid(){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editPid", {sid:_this.sid, pid: _this.shopInfo.pid}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			resetPass(){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/resetPassword", {sid:_this.sid}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			resetPayPass(){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/resetPayPassword", {sid:_this.sid}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			editUsername(){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editUsername", {sid:_this.sid, username: _this.shopInfo.username}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			editRateName(){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editShopRate", {sid:_this.sid, rates: _this.shopInfo.rates}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			editShopName(){
				let _this = this;
				const loading = this.$loading({ lock: true, text: '操作中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'});
				_this.$api.post("/Shop/editShopName", {sid:_this.sid, shop_name: _this.shopInfo.shop_name}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						return _this.$message({
							 message: res.msg,
							 type: 'success'
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			getData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '获取数据',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Shop/getShopInfo", {sid:_this.sid}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.shopInfo = res.data;
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			}
		}
	}
</script>

<style scoped>
	
	.pannel {
		padding: 20px;
		width: 360px;
		background-color: #fff;
		border-radius: 10px;
	}
	.title {
		color: #3399ff;
		font-weight: bold;
		font-size: 18px;
		text-align: center;
		padding-bottom: 10px;
		border-bottom: dashed 1px #3399ff;
		margin-bottom: 20px;
	}
	.form-line {
		display: flex; flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		margin: 20px 0;
	}
	.form-name {
		text-align: right;
		width: 100px;
		padding-right: 10px;
	}
	.form-inp {
		width: 200px;
		margin-right: 10px;
	}
</style>